import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { KTIcon } from '../../../../_theme/helpers/components/KTIcon';
import SimpleLoader from './SimpleLoader';

interface SubmitConfirmationModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loader: boolean;
  text: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
  title?: string;
}

const SubmitConfirmationModal: React.FC<SubmitConfirmationModalProps> = ({
  show,
  onClose,
  onConfirm,
  loader,
  text = '',
  title,
  cancelButtonText = 'Cancel',
  confirmButtonText = 'Yes',
}) => {
  return (
    <>
      <Modal
        show={show}
        onHide={onClose}
        dialogClassName='modal-dialog modal-dialog-centered position-relative'
        backdrop="static" keyboard={false}
      >
        {(loader) && <SimpleLoader className={"bg-black-30 z-2"} />}
        <div className='modal-header pb-5'>
          <h2>{title || 'Submit Confirmation'}</h2>
          <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={onClose}>
            <KTIcon className='fs-1' iconName='cross' />
          </div>
        </div>
        <div className='modal-body text-center'>
          <p className='fs-5'>{text}</p>
        </div>
        <Modal.Footer className='justify-content-center'>
          <Button variant='secondary' onClick={onClose}>
            {cancelButtonText}
          </Button>
          <Button
            variant='primary'
            onClick={onConfirm}
            disabled={loader}
          >
            {confirmButtonText}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SubmitConfirmationModal;
